export const TRACKING_EVENTS = {
    FAVORITE_BOOK: 'added_book_to_favorites',
    UNFAVORITE_BOOK: 'removed_book_from_favorites'
}